/**
 * Spacing and border radius tokens — shared between mobile and admin.
 */

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
} as const;

export const borderRadius = {
  /** Subtle rounding — small chips, badges */
  sm: 4,
  /** Default rounding — buttons, inputs */
  md: 8,
  /** Cards, containers */
  lg: 12,
  /** Prominent rounding — FABs, large cards */
  xl: 16,
  /** Fully rounded — avatar, pill shapes */
  full: 9999,
} as const;

export type Spacing = typeof spacing;
export type BorderRadius = typeof borderRadius;
